import { connect } from 'react-redux';
import LineChartComponent from '../Components/LineChartComponent';
import {
  chart as chartHelpers,
  date as dateHelpers
} from '../helpers';
import { buildHealth as buildHealthSelectors } from '../selectors';
import { uniq } from 'lodash';

export const mapStateToProps = (state) => {
  const builds = buildHealthSelectors.getBuildHealthPageBuilds(state);
  const buildNumbers = uniq(builds.map(b => b.build)).sort();

  const dispatcherTypes = buildHealthSelectors.getAllDispatcherTypes(state).sort();
  const chartProps = buildHealthSelectors.getTrendingChartPropMappedData(state);

  const props = {
    stacked: false,
    data: chartProps.data || [],
    series: chartProps.series || [],
    labels: buildNumbers,
    options: {
      layout: { padding: { left: 10 }},
      legend: { display: false },
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        xAxes: [{ offset: true }],
        yAxes: [{
          ticks: {
            callback: (value) => {
              return dispatcherTypes[value];
            }
          }
        }]
      },
      tooltips: {
        callbacks: {
          footer: (tooltipItem) => {
            const index = tooltipItem[0].index;
            const build = builds[index];
            return dateHelpers.friendlyDate(build.updated_at);
          },
          label: (tooltipItem) => {
            return dispatcherTypes[tooltipItem.yLabel];
          }
        }
      }
    },
    pointOptions: chartHelpers.formatPointOptionArray(
      chartProps.pointOptions)
  };
  return props;
};

export default connect(
  mapStateToProps,
  null
)(LineChartComponent);


// WEBPACK FOOTER //
// src/Containers/BuildHealthTrendingChartContainer.jsx